export type NotificationTemplateVariableInfo = {
  variables: string[]
  note?: string
}

const SESSION_VARIABLES = ["name", "courseName", "startTime"]

const TEMPLATE_VARIABLES_BY_SLUG: Record<string, NotificationTemplateVariableInfo> = {
  cancelled: {
    variables: SESSION_VARIABLES,
  },
  moved: {
    variables: SESSION_VARIABLES,
  },
  min_participants_not_reached: {
    variables: SESSION_VARIABLES,
  },
  manual: {
    variables: SESSION_VARIABLES,
    note: "{courseName} und {startTime} werden nur bei termingebundenen Nachrichten befuellt.",
  },
}

const DEFAULT_TEMPLATE_VARIABLES: NotificationTemplateVariableInfo = {
  variables: SESSION_VARIABLES,
  note: "Die verfuegbaren Variablen werden vom Versand fest vorgegeben.",
}

export function getTemplateVariableInfo(slug?: string | null): NotificationTemplateVariableInfo {
  if (!slug) {
    return DEFAULT_TEMPLATE_VARIABLES
  }

  return TEMPLATE_VARIABLES_BY_SLUG[slug] ?? DEFAULT_TEMPLATE_VARIABLES
}
